import React from 'react';

const ReactionIcon = () => {
    return (
        <svg
            width='33'
            height='32'
            viewBox='0 0 33 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            {/* <circle cx="16.5" cy="16" r="16" fill="#696969" fillOpacity="0.6" /> */}
            <path
                d='M16.4893 5.33333C10.6013 5.33333 5.83325 10.112 5.83325 16C5.83325 21.888 10.6013 26.6667 16.4893 26.6667C22.3879 26.6667 27.1666 21.888 27.1666 16C27.1666 10.112 22.3879 5.33333 16.4893 5.33333ZM12.7666 11.7333C13.6519 11.7333 14.3666 12.448 14.3666 13.3333C14.3666 14.2187 13.6519 14.9333 12.7666 14.9333C11.8813 14.9333 11.1666 14.2187 11.1666 13.3333C11.1666 12.448 11.8813 11.7333 12.7666 11.7333ZM16.4999 22.4C14.0679 22.4 11.9986 20.6293 11.1666 18.1333H21.8333C21.0013 20.6293 18.9319 22.4 16.4999 22.4ZM20.2333 14.9333C19.3479 14.9333 18.6333 14.2187 18.6333 13.3333C18.6333 12.448 19.3479 11.7333 20.2333 11.7333C21.1186 11.7333 21.8333 12.448 21.8333 13.3333C21.8333 14.2187 21.1186 14.9333 20.2333 14.9333Z'
                fill='#696969'
            />
        </svg>
    );
};

export default ReactionIcon;
